import type { MaterialNames } from "@/components/material_symbol_names";
import { normalizeExperienceCompetencyName, type ExperienceIndexCategoryId } from "./experienceIndexCategories";

// Material Symbols closest to membership-mobile-app Skills Index icons
// (`CATEGORY_ICONS` / `COMPETENCY_ICONS` in SkillsIndexResultsScreen.tsx).
export const EXPERIENCE_INDEX_CATEGORY_ICONS: Record<ExperienceIndexCategoryId, MaterialNames> = {
  all: "grid_view",
  "business-administration": "work",
  "people-communication": "groups",
  "coaching-development": "school",
  "facility-program-operations": "storefront"
};

// Canonical keys are catalog slugs (Rails `name.parameterize`). Change an icon here
// and both Results and the assessment page update.
const EXPERIENCE_INDEX_COMPETENCY_ICONS: Record<string, MaterialNames> = {
  admin: "assignment",
  budget: "calculate",
  "course-maintenance": "park",
  "financial-acumen": "show_chart",
  "food-beverage": "restaurant",
  "golf-academy": "sports_golf",
  merchandise: "sell",
  network: "group",
  operator: "settings",
  personnel: "badge",
  "public-speaking": "mic",
  "social-media": "campaign",
  "teaching-and-coaching": "school",
  technology: "devices",
  "tournament-operations": "emoji_events"
};

const DEFAULT_COMPETENCY_ICON: MaterialNames = "assignment";

function experienceIndexCompetencySlug(competencyName: string, slug?: string | null) {
  const catalogSlug = slug?.trim().toLowerCase();
  if (catalogSlug) {
    return catalogSlug;
  }

  return normalizeExperienceCompetencyName(competencyName)
    .replace(/&/g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getExperienceIndexCompetencyIcon(competencyName: string, slug?: string | null): MaterialNames {
  return (
    EXPERIENCE_INDEX_COMPETENCY_ICONS[experienceIndexCompetencySlug(competencyName, slug)] ?? DEFAULT_COMPETENCY_ICON
  );
}
